import axios from 'axios';

// API base URL configuration
// - Vite dev server: http://localhost:8000/api (direct to backend)
// - Docker build: /api (proxied by nginx to backend)
// - VITE_API_BASE_PATH env var overrides for staging/prod deployments
const getBaseURL = () => {
  // Environment variable override (set at build time for staging/prod)
  if (import.meta.env.VITE_API_BASE_PATH) {
    return import.meta.env.VITE_API_BASE_PATH;
  }

  // Production build (Docker): use relative /api path, nginx proxies to backend
  if (import.meta.env.PROD) {
    return '/api';
  }

  // Vite dev server: direct connection to backend
  return import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
};

export const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 90000,  // 90 seconds - LLM pipeline calls can take 30-60 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);
